import type { ACCOUNT_ERROR_CODES } from "@amtana/account-contract";
import type { ErrorCopyFor } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import type { Catalogs, Translation } from "@amtana/i18n/catalog";

// What a user reads when an account change fails (packages/module ADR-001).

const EN = {
  emailTakenTitle: "That email is already in use",
  emailTakenDescription: "Another account uses it. Sign in to that account, or use a different email.",
  avatarInvalidTitle: "That file could not be read as an image",
  avatarInvalidDescription: "Choose a PNG, JPEG or WebP image.",
  avatarTooLargeTitle: "That image is too large",
  avatarTooLargeDescription: "Choose a smaller image.",
  avatarUnsupportedTitle: "That file type is not supported",
  avatarUnsupportedDescription: "Choose a PNG, JPEG or WebP image.",
  staffErasureInputInvalidTitle: "This erasure needs more detail",
  staffErasureInputInvalidDescription: "Enter your staff id and a reason before erasing this person.",
} as const;

const ES: Translation<typeof EN> = {
  emailTakenTitle: "Ese correo ya está en uso",
  emailTakenDescription: "Lo usa otra cuenta. Inicia sesión en esa cuenta o usa otro correo.",
  avatarInvalidTitle: "No se pudo leer ese archivo como imagen",
  avatarInvalidDescription: "Elige una imagen PNG, JPEG o WebP.",
  avatarTooLargeTitle: "Esa imagen es demasiado grande",
  avatarTooLargeDescription: "Elige una imagen más pequeña.",
  avatarUnsupportedTitle: "Ese tipo de archivo no es compatible",
  avatarUnsupportedDescription: "Elige una imagen PNG, JPEG o WebP.",
  staffErasureInputInvalidTitle: "Esta eliminación necesita más detalle",
  staffErasureInputInvalidDescription: "Ingresa tu id de staff y un motivo antes de eliminar a esta persona.",
};

export const ACCOUNT_ERROR_CATALOGS: Catalogs<typeof EN> = { en: EN, es: ES };

export const ACCOUNT_ERROR_COPY = {
  account_email_taken: {
    title: phrase(ACCOUNT_ERROR_CATALOGS, "emailTakenTitle"),
    description: phrase(ACCOUNT_ERROR_CATALOGS, "emailTakenDescription"),
  },
  account_avatar_invalid: {
    title: phrase(ACCOUNT_ERROR_CATALOGS, "avatarInvalidTitle"),
    description: phrase(ACCOUNT_ERROR_CATALOGS, "avatarInvalidDescription"),
  },
  account_avatar_too_large: {
    title: phrase(ACCOUNT_ERROR_CATALOGS, "avatarTooLargeTitle"),
    description: phrase(ACCOUNT_ERROR_CATALOGS, "avatarTooLargeDescription"),
  },
  account_avatar_unsupported_type: {
    title: phrase(ACCOUNT_ERROR_CATALOGS, "avatarUnsupportedTitle"),
    description: phrase(ACCOUNT_ERROR_CATALOGS, "avatarUnsupportedDescription"),
  },
  account_staff_erasure_input_invalid: {
    title: phrase(ACCOUNT_ERROR_CATALOGS, "staffErasureInputInvalidTitle"),
    description: phrase(ACCOUNT_ERROR_CATALOGS, "staffErasureInputInvalidDescription"),
  },
} satisfies ErrorCopyFor<typeof ACCOUNT_ERROR_CODES>;
